<template>
  <el-form
    ref="forgotPasswordForm"
    class="forgotPasswordForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <el-form-item
      :label="$t('auth.forgotPassword.form.forgotPasswordLabel')"
      prop="email"
    >
      <el-input
        v-model="form.email"
        name="email"
        :placeholder="$t('auth.forgotPassword.form.forgotPasswordPlaceholder')"
      />
    </el-form-item>

    <el-button
      class="forgotPasswordForm__submit"
      :type="form.email ? 'primary' : 'default'"
      :loading="loading"
      native-type="submit"
    >{{ $t('auth.forgotPassword.form.submitButton') }}</el-button>
  </el-form>
</template>

<script>
export default {
  name: "ForgotPasswordForm",
  data: () => ({
    loading: false,
    form: {
      email: null
    }
  }),
  computed: {
    rules() {
      return {
        email: { type: "email", required: true, trigger: 'blur', message: this.$t('forms.validation.invalidEmail') }
      }
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const result = await this.$refs['forgotPasswordForm'].validate()

        if (result) {
          await this.$store.dispatch('customer/forgotPassword', this.form)

          this.$notify({
            type: 'success',
            title: this.$t('base.success.notificationTitle'),
            message: this.$t('auth.forgotPassword.form.forgotPasswordNotificationSuccess')
          })

          this.$router.push({
            name: 'login'
          })
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$notify({
          type: 'error',
          title: this.$t('base.errors.notificationTitle'),
          message: this.$t('base.errors.emailMessage')
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.forgotPasswordForm';

#{$c} {
  #{$c}__submit {
    margin-top: 56px;
  }

  #{$c}__options {
    text-align: left;

    #{$c}__options-login {
      font-style: italic;
      font-size: 16px;
      margin-top: -8px;

      a {
        text-decoration: underline;
      }
    }
  }
}
</style>